import { sortBy } from 'utils/functions';

export const addCachedDetail = (client, query, variables, identifier, item, sortByFields) => {
  const data = client.readQuery({ query: query.value, variables });
  if (!data[query.name]) return;
  const items = [...data[query.name]];
  if (!items.find(x => identifier(x))) {
    items.push(item);
  } else {
    const existingIndex = items.findIndex(x => identifier(x));
    items[existingIndex] = item;
  }
  sortBy(items, sortByFields);
  client.writeQuery({ query: query.value, variables, data: { [query.name]: items } });
};

export const removeCachedDetail = (client, query, variables, identifier, sortByFields) => {
  const data = client.readQuery({ query: query.value, variables });
  if (!data[query.name]) return;
  let items = [...data[query.name]];
  items = items.filter(x => !identifier(x));
  sortBy(items, sortByFields);
  client.writeQuery({ query: query.value, variables, data: { [query.name]: items } });
  client.cache.gc();
};
